var _path, _stop, _stop2, _stop3, _stop4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgIsBrandSelected(props) {
  const _id2 = useUniqueInlineId();
  const _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.59 8.735a1.058 1.058 0 010-1.38c.243-.283.488-.562.733-.837a57.453 57.453 0 01-.214-1.08 1.058 1.058 0 01.69-1.194 56.63 56.63 0 011.054-.358c.114-.346.232-.693.354-1.042.173-.494.68-.787 1.194-.69.362.068.72.14 1.075.213.27-.241.544-.482.823-.721.397-.341.983-.341 1.38 0 .28.241.556.483.827.725.36-.075.725-.148 1.093-.217a1.058 1.058 0 011.194.69c.123.35.24.696.354 1.042.35.115.701.234 1.055.358.494.174.786.68.69 1.195-.07.37-.143.735-.219 1.097.247.276.492.557.738.842.341.397.341.982 0 1.38-.244.283-.488.563-.734.837.075.356.146.716.214 1.08a1.057 1.057 0 01-.69 1.194c-.353.124-.704.244-1.054.359-.114.345-.232.692-.354 1.041-.173.494-.68.787-1.194.69-.362-.068-.72-.139-1.074-.213-.27.242-.545.482-.824.722-.397.34-.983.34-1.38 0a57.64 57.64 0 01-.827-.726c-.36.076-.724.148-1.093.217a1.058 1.058 0 01-1.194-.69c-.122-.349-.24-.696-.354-1.041-.35-.115-.701-.235-1.055-.359a1.058 1.058 0 01-.69-1.194c.07-.37.143-.736.219-1.098a57.328 57.328 0 01-.738-.842z",
    fill: `url(#${_id})`,
    stroke: `url(#${_id2})`
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.754 8.618l1.634 1.685c.768-2.208 1.409-3.177 2.859-4.493",
    stroke: "#fff"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: _id,
    x1: 1.359,
    y1: 1.44,
    x2: 1.359,
    y2: 14.723,
    gradientUnits: "userSpaceOnUse"
  }, _stop || (_stop = /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#17C868"
  })), _stop2 || (_stop2 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#62BD00"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id2,
    x1: 1.359,
    y1: 1.44,
    x2: 1.359,
    y2: 14.723,
    gradientUnits: "userSpaceOnUse"
  }, _stop3 || (_stop3 = /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#17C868"
  })), _stop4 || (_stop4 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#62BD00"
  })))));
}
export default SvgIsBrandSelected;